import { useState, useEffect, useRef } from "react";
import "../Testimonials/Testimonials.css";

const TestimonialSlider = () => {
  const [active, setActive] = useState(0);
  const [autorotate, setAutorotate] = useState(true);
  const testimonialsRef = useRef(null);
  const autorotateTiming = 7000;

  const testimonials = [
    {
      img: "/testi1.webp",
      quote:
        "The team guided me with clarity through a complex legal matter. Their attention to detail and timely updates made the entire process much less stressful.",
      name: "Rohan Mehra",
      role: "Entrepreneur, Bengaluru",
    },
    {
      img: "/testi2.webp",
      quote:
        "Professional, reliable, and thorough — they handled my company’s legal compliance issues with great efficiency. Highly recommended for any business owner.",
      name: "Vikram Sharma",
      role: "CEO, Delhi",
    },
    {
      img: "testi3.webp",
      quote:
        "I approached them for a family property dispute. Their strategic approach and calm guidance helped me win the case without unnecessary delays.",
      name: "Arjun Patel",
      role: "Investor, Ahmedabad",
    },
  ];

  useEffect(() => {
    let interval;
    if (autorotate) {
      interval = setInterval(() => {
        setActive((prev) => (prev + 1 === testimonials.length ? 0 : prev + 1));
      }, autorotateTiming);
    }
    return () => clearInterval(interval);
  }, [autorotate, testimonials.length]);

  useEffect(() => {
    heightFix();
  }, [active]);

  const heightFix = () => {
    if (testimonialsRef.current && testimonialsRef.current.children[active]) {
      testimonialsRef.current.style.height = `${testimonialsRef.current.children[active].offsetHeight}px`;
    }
  };

  const stopAutorotate = () => {
    setAutorotate(false);
  };

  const handleButtonClick = (index) => {
    setActive(index);
    stopAutorotate();
  };

  return (
    <div className="testimonial-slider">
      <main className="testimonial-main">
        <div className="header-t">
          <h1 className="faded-text-t">FEEDBACK</h1>
        </div>
        <div className="testimonial-container">
          <div className="flex justify-center">
            <div className="testimonial-slider-component">
              {/* Testimonial image with curved gradient */}
              <div className="testimonial-image-container">
                <div className="testimonial-image-wrapper">
                  <div className="testimonial-image-mask">
                    {testimonials.map((testimonial, index) => (
                      <div
                        key={index}
                        className={`testimonial-image ${active === index ? "active" : "inactive"}`}
                      >
                        <img
                          src={testimonial.img}
                          alt={testimonial.name}
                          width="56"
                          height="56"
                        />
                      </div>
                    ))}
                  </div>
                </div>
              </div>

              {/* Testimonial text */}
              <div className="testimonial-text-container">
                <div className="testimonial-text-wrapper" ref={testimonialsRef}>
                  {testimonials.map((testimonial, index) => (
                    <div
                      key={index}
                      className={`testimonial-text ${active === index ? "active" : "inactive"}`}
                    >
                      <div className="testimonial-quote">
                        {testimonial.quote}
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              {/* Navigation buttons */}
              <div className="testimonial-buttons">
                {testimonials.map((testimonial, index) => (
                  <button
                    key={index}
                    className={`testimonial-button ${active === index ? "active" : "inactive"}`}
                    onClick={() => handleButtonClick(index)}
                  >
                    <span>{testimonial.name}</span>
                    <span
                      className={`testimonial-separator ${active === index ? "active" : "inactive"}`}
                    >
                      -
                    </span>
                    <span>{testimonial.role}</span>
                  </button>
                ))}
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default TestimonialSlider;
